import type { IxdReportPeriodType } from "@/apis/ixd-editor/types";
import {
  PeriodChip,
  YearChip,
  type ReportPeriod,
} from "@/components/common/report-chip";

const reportPeriodByIxdPeriodType: Record<IxdReportPeriodType, ReportPeriod> = {
  // PeriodChip의 Q4 표시 문구가 사업보고서용 "사업"이다.
  ANNUAL: "Q4",
  FIRST_QUARTER: "Q1",
  HALF_YEAR: "Q2",
  THIRD_QUARTER: "Q3",
};

/** API enum이 먼저 확장돼 프론트 타입보다 새로운 값이 와도 chip을 그리지 않도록 undefined를 준다. */
export const toReportPeriod = (
  periodType: string | null | undefined,
): ReportPeriod | undefined =>
  typeof periodType === "string"
    ? (reportPeriodByIxdPeriodType as Partial<Record<string, ReportPeriod>>)[
        periodType
      ]
    : undefined;

interface IxdReportNameProps {
  fileName: string;
  periodYear?: number | null;
  periodType?: IxdReportPeriodType | null;
}

type IxdReportChipsProps = Pick<
  IxdReportNameProps,
  "periodYear" | "periodType"
>;

export const IxdReportChips = ({
  periodYear,
  periodType,
}: IxdReportChipsProps) => {
  const period = toReportPeriod(periodType);
  if (periodYear == null && period == null) return null;

  return (
    <span data-ixd-report-chips className="flex min-w-0 items-center gap-1">
      {periodYear != null && (
        <YearChip year={periodYear} className="shrink-0" />
      )}
      {period != null && <PeriodChip period={period} className="shrink-0" />}
    </span>
  );
};

export const IxdReportName = ({
  fileName,
  periodYear,
  periodType,
}: IxdReportNameProps) => (
  <span className="flex w-full min-w-0 items-center gap-1 overflow-hidden">
    <IxdReportChips periodYear={periodYear} periodType={periodType} />
    <span className="min-w-0 flex-1 truncate">{fileName}</span>
  </span>
);
